(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1556],{

/***/ 29795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(962);
/* harmony import */ var _accordion_accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85256);
/* harmony import */ var _media_media__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38925);
/* harmony import */ var _spacer_spacer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4363);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28773);
/* harmony import */ var _faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43995);
/* harmony import */ var _faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var FaqBox = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["faq-box"]) + " " + (props === null || props === void 0 ? void 0 : props.className),
        "data-testid": "faq-box",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                variant: ((ref = props.Headline) === null || ref === void 0 ? void 0 : ref.style) ? (0,_utils_helper_strapi_mapper__WEBPACK_IMPORTED_MODULE_3__/* .mapStrapiHeadline */ .z)(props.Headline.style) : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.HEADING2_BOLD */ .H.HEADING2_BOLD,
                element: (ref7 = (ref1 = props.Headline) === null || ref1 === void 0 ? void 0 : ref1.element) !== null && ref7 !== void 0 ? ref7 : undefined,
                style: {
                    textAlign: (ref2 = props.Headline) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.textAlign) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.toLowerCase) === null || ref4 === void 0 ? void 0 : ref4.call(ref3)
                },
                inverted: props.inverted,
                children: (ref5 = props.Headline) === null || ref5 === void 0 ? void 0 : ref5.headlineContent
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_spacer_spacer__WEBPACK_IMPORTED_MODULE_6__/* .Spacer */ .L, {
                height: "40px"
            }),
            (ref6 = props.fa_qs) === null || ref6 === void 0 ? void 0 : ref6.map(function(param) {
                var _faqs = param.faqs, description = _faqs.description, headline = _faqs.headline, image = _faqs.image, initialOpen = _faqs.initialOpen;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_accordion_accordion__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    initialOpen: initialOpen !== null && initialOpen !== void 0 ? initialOpen : false,
                    label: headline,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["faq-item-content"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["faq-item-description-wrapper"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .Z, {
                                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .TypographyVariantsEnum.BODY */ .H.BODY,
                                    className: (_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["faq-item-description"]),
                                    children: description
                                })
                            }),
                            image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_faq_box_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["faq-item-image"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_media_media__WEBPACK_IMPORTED_MODULE_5__/* .Media */ .pU, {
                                    alt: image.alternativeText,
                                    objectFit: "contain",
                                    src: image.url
                                })
                            }) : undefined
                        ]
                    })
                }, headline);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqBox);


/***/ }),

/***/ 48500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90017);
/* harmony import */ var _utils_enums_horizontal_position_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40579);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27397);
/* harmony import */ var _media_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38925);
/* harmony import */ var _teaser_card_components_teaser_card_text_teaser_card_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33997);
/* harmony import */ var _video_component_video_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60446);
/* harmony import */ var _text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34402);
/* harmony import */ var _text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var TextImageTeaser = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var _buttonUrl, ref10, ref11, ref12;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: "".concat((_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["text-image-teaser"]), " ").concat(props.imgEdgePosition ? (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default())["".concat(props.imgEdgePosition)] : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: props.imagePosition === _utils_enums_horizontal_position_enum__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalPosition.LEFT */ .D.LEFT ? (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["right-wrapper"]) : (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["left-wrapper"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teaser_card_components_teaser_card_text_teaser_card_text__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        headline: props.headline.headlineContent,
                        topline: props.topline.toplineContent,
                        description: props.description.content,
                        variant: _utils_enums_basic_card_variants_enum__WEBPACK_IMPORTED_MODULE_2__/* .BasicCardVariants.TEXT_IMAGE_TEASER */ .I.TEXT_IMAGE_TEASER,
                        inverted: props.inverted
                    }),
                    props.callToAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default().buttons),
                        children: props === null || props === void 0 ? void 0 : (ref = props.callToAction) === null || ref === void 0 ? void 0 : ref.map(function(args) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__/* .LinkBase */ .w, {
                                href: (_buttonUrl = args.buttonUrl) !== null && _buttonUrl !== void 0 ? _buttonUrl : "",
                                external: (ref10 = args === null || args === void 0 ? void 0 : args.external) !== null && ref10 !== void 0 ? ref10 : false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({
                                    inverted: props.inverted,
                                    variant: args.variant
                                }, args), args.children)
                            }, args.buttonUrl);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: props.imagePosition === _utils_enums_horizontal_position_enum__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalPosition.LEFT */ .D.LEFT ? (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["left-wrapper-img"]) : (_text_image_teaser_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["right-wrapper-img"]),
                children: [
                    !(props === null || props === void 0 ? void 0 : (ref1 = props.video) === null || ref1 === void 0 ? void 0 : ref1.videoId) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_media_media__WEBPACK_IMPORTED_MODULE_6__/* .Media */ .pU, {
                        alt: (ref11 = (ref2 = props.image) === null || ref2 === void 0 ? void 0 : ref2.alternativeText) !== null && ref11 !== void 0 ? ref11 : "image-teaser-alt",
                        src: (ref12 = props === null || props === void 0 ? void 0 : (ref3 = props.image) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref12 !== void 0 ? ref12 : "",
                        objectFit: "contain"
                    }),
                    (props === null || props === void 0 ? void 0 : (ref4 = props.video) === null || ref4 === void 0 ? void 0 : ref4.platform) && (props === null || props === void 0 ? void 0 : (ref5 = props.video) === null || ref5 === void 0 ? void 0 : ref5.videoId) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_video_component_video_component__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        platform: props === null || props === void 0 ? void 0 : (ref6 = props.video) === null || ref6 === void 0 ? void 0 : ref6.platform,
                        videoId: props === null || props === void 0 ? void 0 : (ref7 = props.video) === null || ref7 === void 0 ? void 0 : ref7.videoId,
                        controls: props === null || props === void 0 ? void 0 : (ref8 = props.video) === null || ref8 === void 0 ? void 0 : ref8.controls,
                        autoplay: props === null || props === void 0 ? void 0 : (ref9 = props.video) === null || ref9 === void 0 ? void 0 : ref9.autoplay
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextImageTeaser);


/***/ }),

/***/ 60446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/utils/_enums/strapi-video-platforms.enum.tsx
var StrapiVideoPlatforms;
(function(StrapiVideoPlatforms) {
    StrapiVideoPlatforms["YOUTUBE"] = "youtube";
    StrapiVideoPlatforms["VIMEO"] = "vimeo";
})(StrapiVideoPlatforms || (StrapiVideoPlatforms = {}));

// EXTERNAL MODULE: ./src/components/_shared/video-component/video-component.module.scss
var video_component_module = __webpack_require__(23553);
var video_component_module_default = /*#__PURE__*/__webpack_require__.n(video_component_module);
;// CONCATENATED MODULE: ./src/components/_shared/video-component/video-component.tsx




var VideoComponent = function(props) {
    var embedCode;
    if (props.platform === StrapiVideoPlatforms.YOUTUBE) {
        embedCode = /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: "https://www.youtube.com/embed/".concat(props === null || props === void 0 ? void 0 : props.videoId).concat((props === null || props === void 0 ? void 0 : props.controls) ? "?" : "?controls=0").concat((props === null || props === void 0 ? void 0 : props.autoplay) ? "&autoplay=1&mute=1" : ""),
            title: "YouTube video player",
            frameBorder: "0",
            allow: "autoplay accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        });
    } else {
        embedCode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: "https://player.vimeo.com/video/".concat(props === null || props === void 0 ? void 0 : props.videoId).concat((props === null || props === void 0 ? void 0 : props.controls) ? "?controls=1" : "?controls=0").concat((props === null || props === void 0 ? void 0 : props.autoplay) || !(props === null || props === void 0 ? void 0 : props.controls) ? "&autoplay=1&muted=1" : ""),
                    frameBorder: "0",
                    allow: "fullscreen; picture-in-picture",
                    allowFullScreen: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    src: "https://player.vimeo.com/api/player.js"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((video_component_module_default())["video-component-wrapper"]),
        children: embedCode
    });
};
/* harmony default export */ var video_component = (VideoComponent);


/***/ }),

/***/ 82997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ArticlePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next-data-hooks/index.esm.js
var index_esm = __webpack_require__(4118);
// EXTERNAL MODULE: ./src/utils/_config/axios.ts
var axios = __webpack_require__(79098);
;// CONCATENATED MODULE: ./src/api/hooks/useArticlePage.hook.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useArticlePage = (0,index_esm/* createDataHook */.Qo)("ArticlePage", function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var locale, params, localeRes, ref, key, value, result, ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = param.locale, params = param.params;
                    localeRes = !locale || locale === "catchAll" ? "en" : locale;
                    if (!params) {
                        _ctx.next = 11;
                        break;
                    }
                    ;
                    key = Object.keys(params)[0];
                    value = Object.values(params).length > 1 ? Object.values(params)[1] : Object.values(params)[0];
                    _ctx.next = 8;
                    return (0,axios/* backend */.y)().get("api/strapi/".concat(key === "articlePage" ? "article-pages" : "confirmation-pages", "?").concat(Object.values(params).length > 1 ? "id=".concat(value, "&_locale=").concat(localeRes) : "_locale=".concat(localeRes, "&urlReadablePageTitle=").concat(value)));
                case 8:
                    result = _ctx.sent;
                    ;
                    return _ctx.abrupt("return", (ref1 = (ref = result.data) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var HorizontalAlignment;
(function(HorizontalAlignment) {
    HorizontalAlignment["LEFT"] = "LEFT";
    HorizontalAlignment["RIGHT"] = "RIGHT";
    HorizontalAlignment["CENTER"] = "CENTER";
    HorizontalAlignment["SPACE_AROUND"] = "SPACE_AROUND";
    HorizontalAlignment["SPACE_BETWEEN"] = "SPACE_BETWEEN";
    HorizontalAlignment["SPACE_EVENLY"] = "SPACE_EVENLY";
})(HorizontalAlignment || (HorizontalAlignment = {}));
var VerticalAlignment;
(function(VerticalAlignment) {
    VerticalAlignment["TOP"] = "TOP";
    VerticalAlignment["BOTTOM"] = "BOTTOM";
    VerticalAlignment["CENTER"] = "CENTER";
    VerticalAlignment["STRETCH"] = "STRETCH";
    VerticalAlignment["BASELINE"] = "BASELINE";
})(VerticalAlignment || (VerticalAlignment = {}));

// EXTERNAL MODULE: ./src/assets/logo-text.svg.tsx
var logo_text_svg = __webpack_require__(91995);
// EXTERNAL MODULE: ./src/components/_shared/basic-card/basic-card.tsx + 2 modules
var basic_card = __webpack_require__(40708);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/contact-form/contact-form.tsx
var contact_form = __webpack_require__(71157);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/_shared/head-image-section/head-image-section.module.scss
var head_image_section_module = __webpack_require__(84059);
var head_image_section_module_default = /*#__PURE__*/__webpack_require__.n(head_image_section_module);
;// CONCATENATED MODULE: ./src/components/_shared/head-image-section/head-image-section.tsx






var HeadImageSection = function(props) {
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: (head_image_section_module_default())["head-image-wrapper"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                src: (ref = props === null || props === void 0 ? void 0 : props.imageUrl) !== null && ref !== void 0 ? ref : "",
                alt: props === null || props === void 0 ? void 0 : props.alt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                inverted: (ref1 = props === null || props === void 0 ? void 0 : props.inverted) !== null && ref1 !== void 0 ? ref1 : false,
                variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                element: "span",
                children: (ref2 = props === null || props === void 0 ? void 0 : props.caption) !== null && ref2 !== void 0 ? ref2 : ""
            })
        ]
    });
};
/* harmony default export */ var head_image_section = (HeadImageSection);

// EXTERNAL MODULE: ./src/utils/_enums/horizontal-position.enum.ts
var horizontal_position_enum = __webpack_require__(40579);
// EXTERNAL MODULE: ./src/components/_shared/head-image-with-text-section/head-image-with-text-section.module.scss
var head_image_with_text_section_module = __webpack_require__(9183);
var head_image_with_text_section_module_default = /*#__PURE__*/__webpack_require__.n(head_image_with_text_section_module);
;// CONCATENATED MODULE: ./src/components/_shared/head-image-with-text-section/head-image-with-text-section.tsx







var HeadImageWithTextSection = function(props) {
    var position = props.imagePosition === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT ? "left" : "right";
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: "".concat((head_image_with_text_section_module_default())["head-image-with-text-wrapper"], " ").concat((head_image_with_text_section_module_default())["".concat(position)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (head_image_with_text_section_module_default())["image-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(head_image_section, {
                    imageUrl: (ref = props === null || props === void 0 ? void 0 : props.imageUrl) !== null && ref !== void 0 ? ref : "",
                    alt: props === null || props === void 0 ? void 0 : props.alt,
                    caption: props === null || props === void 0 ? void 0 : props.caption,
                    inverted: props === null || props === void 0 ? void 0 : props.inverted
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                inverted: props === null || props === void 0 ? void 0 : props.inverted,
                className: (head_image_with_text_section_module_default())["text-container"],
                children: (0,html_react_parser/* default */.ZP)(props === null || props === void 0 ? void 0 : props.text)
            })
        ]
    });
};
/* harmony default export */ var head_image_with_text_section = (HeadImageWithTextSection);

// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./src/components/_shared/number-text-teaser/number-text-teaser.module.scss
var number_text_teaser_module = __webpack_require__(59242);
var number_text_teaser_module_default = /*#__PURE__*/__webpack_require__.n(number_text_teaser_module);
;// CONCATENATED MODULE: ./src/components/_shared/number-text-teaser/number-text-teaser.tsx





var NumberTextTeaser = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: (number_text_teaser_module_default())["number-text-teaser"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                element: "span",
                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1,
                children: props.largeText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                element: "span",
                variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                children: props.subText
            })
        ]
    });
};
/* harmony default export */ var number_text_teaser = (NumberTextTeaser);

// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-footer/teaser-card-footer.tsx
var teaser_card_footer = __webpack_require__(67396);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-text/teaser-card-text.tsx
var teaser_card_text = __webpack_require__(33997);
// EXTERNAL MODULE: ./src/components/_shared/podcast-teaser-card/podcast-teaser-card.module.scss
var podcast_teaser_card_module = __webpack_require__(70482);
var podcast_teaser_card_module_default = /*#__PURE__*/__webpack_require__.n(podcast_teaser_card_module);
;// CONCATENATED MODULE: ./src/components/_shared/podcast-teaser-card/podcast-teaser-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var PodcastTeaserCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((podcast_teaser_card_module_default())["podcast-teaser-card-wrapper"], " ").concat((podcast_teaser_card_module_default())["".concat(props.type ? props.type : "")]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (podcast_teaser_card_module_default())["teaser-card-text"],
                children: [
                    props.label && props.label.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (podcast_teaser_card_module_default())["label-wrapper"],
                        children: props.label.map(function(label, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (podcast_teaser_card_module_default())["label-container"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (podcast_teaser_card_module_default()).label,
                                    children: label.toUpperCase()
                                })
                            }, label + index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, _objectSpread({}, props.text, {
                        variant: props.type,
                        headlineVariant: typeography_variants_enum/* TypographyVariantsEnum.HEADING4_BOLD */.H.HEADING4_BOLD,
                        redirectUrl: props.redirectUrl
                    }))
                ]
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_footer/* default */.Z, _objectSpread({}, props.footer, {
                type: props.type,
                redirectUrl: props.redirectUrl,
                isURLExternal: props.isURLExternal,
                moreInfoLinkText: props.moreInfoLinkText,
                onMoreInfo: props.footer.onPrimaryAction
            }))
        ]
    });
};
/* harmony default export */ var podcast_teaser_card = (PodcastTeaserCard);

// EXTERNAL MODULE: ./src/components/_shared/quote-section/quote-section.module.scss
var quote_section_module = __webpack_require__(46907);
var quote_section_module_default = /*#__PURE__*/__webpack_require__.n(quote_section_module);
;// CONCATENATED MODULE: ./src/components/_shared/quote-section/quote-section.tsx






var QuoteSection = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: "".concat((quote_section_module_default())["quote-section"], " ").concat(props.alignment ? (quote_section_module_default())[props.alignment] : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                props.authorImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                    className: (quote_section_module_default())["author-image"],
                    src: props.authorImage.url,
                    alt: "Author image",
                    hexagon: true
                }) : undefined,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (quote_section_module_default())["quote-wrapper"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        className: "".concat((quote_section_module_default()).quote, " ").concat(props.inverted ? (quote_section_module_default()).inverted : ""),
                        variant: typeography_variants_enum/* TypographyVariantsEnum.QUOTE */.H.QUOTE,
                        inverted: props.inverted,
                        children: props.text
                    })
                }),
                props.authorName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (quote_section_module_default())["author-name"],
                    inverted: props.inverted,
                    variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING6 */.H.HEADING6,
                    children: props.authorName
                }) : undefined,
                props.authorTitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (quote_section_module_default())["author-title"],
                    inverted: props.inverted,
                    variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                    children: props.authorTitle
                }) : undefined
            ]
        })
    });
};
/* harmony default export */ var quote_section = (QuoteSection);

// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/stage/stage.tsx
var stage = __webpack_require__(70818);
// EXTERNAL MODULE: ./src/components/_shared/text-image-teaser/text-image-teaser.tsx
var text_image_teaser = __webpack_require__(48500);
// EXTERNAL MODULE: ./src/api/hooks/useCardText.hook.ts
var useCardText_hook = __webpack_require__(14375);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
;// CONCATENATED MODULE: ./src/utils/_enums/text-only-teaser-sizes.enum.ts
var TextOnlyTeaserSizes;
(function(TextOnlyTeaserSizes) {
    TextOnlyTeaserSizes["SMALL"] = "small";
    TextOnlyTeaserSizes["MEDIUM"] = "medium";
    TextOnlyTeaserSizes["LARGE"] = "large";
})(TextOnlyTeaserSizes || (TextOnlyTeaserSizes = {}));

// EXTERNAL MODULE: ./src/utils/_helper/strapi-mapper.tsx
var strapi_mapper = __webpack_require__(962);
// EXTERNAL MODULE: ./src/components/_shared/link/link.tsx
var link_link = __webpack_require__(46164);
// EXTERNAL MODULE: ./src/components/_shared/link/link-base/link-base.tsx
var link_base = __webpack_require__(27397);
// EXTERNAL MODULE: ./src/components/_shared/video-component/video-component.tsx + 1 modules
var video_component = __webpack_require__(60446);
// EXTERNAL MODULE: ./src/components/_shared/text-only-teaser/text-only-teaser.module.scss
var text_only_teaser_module = __webpack_require__(84298);
var text_only_teaser_module_default = /*#__PURE__*/__webpack_require__.n(text_only_teaser_module);
;// CONCATENATED MODULE: ./src/components/_shared/text-only-teaser/text-only-teaser.tsx














var TextOnlyTeaser = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    var data = (0,useCardText_hook/* useCardText */.G)();
    var ref26, ref27, ref28;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((text_only_teaser_module_default())["text-only-teaser-wrapper"], "\n            ").concat((text_only_teaser_module_default())["text-only-teaser-wrapper-".concat(props.size)]),
        children: [
            props.imageUrl && !(props === null || props === void 0 ? void 0 : (ref = props.video) === null || ref === void 0 ? void 0 : ref.videoId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                src: (ref26 = props === null || props === void 0 ? void 0 : props.imageUrl) !== null && ref26 !== void 0 ? ref26 : "",
                objectFit: "contain"
            }),
            (props === null || props === void 0 ? void 0 : (ref1 = props.video) === null || ref1 === void 0 ? void 0 : ref1.platform) && (props === null || props === void 0 ? void 0 : (ref2 = props.video) === null || ref2 === void 0 ? void 0 : ref2.videoId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                platform: props === null || props === void 0 ? void 0 : (ref3 = props.video) === null || ref3 === void 0 ? void 0 : ref3.platform,
                videoId: props === null || props === void 0 ? void 0 : (ref4 = props.video) === null || ref4 === void 0 ? void 0 : ref4.videoId,
                controls: props === null || props === void 0 ? void 0 : (ref5 = props.video) === null || ref5 === void 0 ? void 0 : ref5.controls,
                autoplay: props === null || props === void 0 ? void 0 : (ref6 = props.video) === null || ref6 === void 0 ? void 0 : ref6.autoplay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (text_only_teaser_module_default()).text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_text/* default */.Z, {
                    headline: props.text.headline.headlineContent,
                    headlineElement: props.text.headline.element,
                    headlineVariant: (0,strapi_mapper/* mapStrapiHeadline */.z)((ref7 = props.text.headline) === null || ref7 === void 0 ? void 0 : ref7.style),
                    headlineStyle: {
                        textAlign: (ref8 = props.text.headline.textAlign) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.toLowerCase) === null || ref9 === void 0 ? void 0 : ref9.call(ref8)
                    },
                    subHeadline: (ref10 = props.text) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.subHeadline) === null || ref11 === void 0 ? void 0 : ref11.headlineContent,
                    subHeadlineElement: (ref12 = props.text) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.subHeadline) === null || ref13 === void 0 ? void 0 : ref13.element,
                    subHeadlineVariant: (0,strapi_mapper/* mapStrapiHeadline */.z)((ref14 = props.text) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.subHeadline) === null || ref15 === void 0 ? void 0 : ref15.style),
                    subHeadlineStyle: {
                        textAlign: (ref16 = props.text) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.subHeadline) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.textAlign) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.toLowerCase) === null || ref19 === void 0 ? void 0 : ref19.call(ref18)
                    },
                    description: props.text.description,
                    inverted: props.inverted,
                    variant: props.size === TextOnlyTeaserSizes.LARGE ? basic_card_variants_enum/* BasicCardVariants.TEXT_ONLY_TEASER_LARGE */.I.TEXT_ONLY_TEASER_LARGE : basic_card_variants_enum/* BasicCardVariants.TEXT_ONLY_TEASER_NORMAL */.I.TEXT_ONLY_TEASER_NORMAL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (text_only_teaser_module_default()).footer,
                children: [
                    props.footer.onAction && (props === null || props === void 0 ? void 0 : (ref20 = props.ghostButton) === null || ref20 === void 0 ? void 0 : ref20.buttonText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_base/* LinkBase */.w, {
                            href: (ref27 = props === null || props === void 0 ? void 0 : (ref21 = props.ghostButton) === null || ref21 === void 0 ? void 0 : ref21.buttonUrl) !== null && ref27 !== void 0 ? ref27 : "",
                            external: props === null || props === void 0 ? void 0 : (ref22 = props.ghostButton) === null || ref22 === void 0 ? void 0 : ref22.external,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                variant: button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED,
                                inverted: props.inverted,
                                children: props === null || props === void 0 ? void 0 : (ref23 = props.ghostButton) === null || ref23 === void 0 ? void 0 : ref23.buttonText
                            })
                        })
                    }),
                    props.footer.onMoreInfo && (props === null || props === void 0 ? void 0 : props.buttonUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (text_only_teaser_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                            href: (ref28 = props === null || props === void 0 ? void 0 : (ref24 = props.buttonUrl) === null || ref24 === void 0 ? void 0 : ref24.url) !== null && ref28 !== void 0 ? ref28 : "",
                            inverted: props.inverted,
                            external: props === null || props === void 0 ? void 0 : (ref25 = props.buttonUrl) === null || ref25 === void 0 ? void 0 : ref25.external,
                            children: props.text.buttonText ? props.text.buttonText : (data === null || data === void 0 ? void 0 : data.readMore) ? data.readMore : ""
                        })
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var text_only_teaser = (TextOnlyTeaser);

;// CONCATENATED MODULE: ./src/components/article-page/article-page-bookmark/article-page-bookmark.tsx


var ArticlePageBookmark = function(param) {
    var id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id
    });
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
;// CONCATENATED MODULE: ./src/api/hooks/useResolveFaqItems.hook.ts
function useResolveFaqItems_hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useResolveFaqItems_hook_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useResolveFaqItems_hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useResolveFaqItems_hook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var useResolveFaqItems = function(fa_qs) {
    return (0,es.useQuery)([
        "resolve-faq-items",
        fa_qs
    ], useResolveFaqItems_hook_asyncToGenerator(runtime_default().mark(function _callee1() {
        var res;
        return runtime_default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    _ctx1.next = 2;
                    return Promise.all(fa_qs === null || fa_qs === void 0 ? void 0 : fa_qs.map(function() {
                        var _ref = useResolveFaqItems_hook_asyncToGenerator(runtime_default().mark(function _callee(faqIdItem) {
                            var id;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        id = faqIdItem.id;
                                        _ctx.next = 3;
                                        return (0,axios/* backend */.y)().get("api/strapi/fa-qs/".concat(id));
                                    case 3:
                                        return _ctx.abrupt("return", _ctx.sent.data);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(faqIdItem) {
                            return _ref.apply(this, arguments);
                        };
                    }()));
                case 2:
                    res = _ctx1.sent;
                    return _ctx1.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    })));
};

// EXTERNAL MODULE: ./src/components/_shared/faq-box/faq-box.tsx
var faq_box = __webpack_require__(29795);
// EXTERNAL MODULE: ./src/components/article-page/article-page-faq-box/article-page-faq-box.module.scss
var article_page_faq_box_module = __webpack_require__(2815);
var article_page_faq_box_module_default = /*#__PURE__*/__webpack_require__.n(article_page_faq_box_module);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-faq-box/article-page-faq-box.tsx
function article_page_faq_box_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_page_faq_box_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_page_faq_box_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var ArticlePageFaqBox = function(props) {
    var ref;
    var ref1 = useResolveFaqItems((ref = props === null || props === void 0 ? void 0 : props.fa_qs) !== null && ref !== void 0 ? ref : []), faqs = ref1.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(faq_box/* default */.Z, article_page_faq_box_objectSpread({}, props, {
        className: (article_page_faq_box_module_default())["article-page-faq-box"],
        fa_qs: faqs !== null && faqs !== void 0 ? faqs : []
    }));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/_shared/newsletter-input/newsletter-input.tsx + 1 modules
var newsletter_input = __webpack_require__(48887);
// EXTERNAL MODULE: ./src/components/article-page/article-page-newsletter/article-page-newsletter.module.scss
var article_page_newsletter_module = __webpack_require__(34775);
var article_page_newsletter_module_default = /*#__PURE__*/__webpack_require__.n(article_page_newsletter_module);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-newsletter/article-page-newsletter.tsx







var ArticlePageNewsletter = function(props) {
    var ref, ref1;
    var _cssClass;
    return props.headline && props.description && props.newsletterInput ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: (article_page_newsletter_module_default())["article-page-newsletter"],
        children: [
            (props === null || props === void 0 ? void 0 : (ref = props.backgroundImage) === null || ref === void 0 ? void 0 : (ref1 = ref.imageUpload) === null || ref1 === void 0 ? void 0 : ref1.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: props.backgroundImage.imageUpload.url,
                layout: "fill",
                objectPosition: "top",
                objectFit: "cover"
            }) : undefined,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_page_newsletter_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        inverted: props.inverted,
                        variant: typeography_variants_enum/* TypographyVariantsEnum.HEADING3_BOLD */.H.HEADING3_BOLD,
                        className: (article_page_newsletter_module_default())["newsletter-headline"],
                        element: (_cssClass = props.headline.cssClass) !== null && _cssClass !== void 0 ? _cssClass : "h3",
                        children: props.headline.headlineContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                        inverted: props.inverted,
                        children: props.description.content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_page_newsletter_module_default())["newsletter-input-wrapper"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_input/* default */.Z, {
                            inverted: props.inverted,
                            className: (article_page_newsletter_module_default())["newsletter-input"],
                            inputTexts: props.newsletterInput,
                            errorMessage: props.errorSnackbar,
                            successMessage: props.successSnackbar,
                            otherIcon: [
                                "fas",
                                "paper-plane"
                            ]
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
};
/* harmony default export */ var article_page_newsletter = (ArticlePageNewsletter);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var react_redux_es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
;// CONCATENATED MODULE: ./src/utils/_enums/article-page-product-teaser-variant.enum.ts
var ArticlePageProductTeaserVariant;
(function(ArticlePageProductTeaserVariant) {
    ArticlePageProductTeaserVariant["UNIQUE_INSTANCES"] = "UNIQUE_INSTANCES";
    ArticlePageProductTeaserVariant["FUTURE_RELEASE"] = "FUTURE_RELEASE";
})(ArticlePageProductTeaserVariant || (ArticlePageProductTeaserVariant = {}));

// EXTERNAL MODULE: ./src/utils/_enums/filter-expression.enum.tsx
var filter_expression_enum = __webpack_require__(55190);
// EXTERNAL MODULE: ./src/utils/_helper/time-helper.tsx
var time_helper = __webpack_require__(28508);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-product-teaser/article-page-product-teaser.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var ArticlePageProductTeaser = function(param) {
    var headline = param.headline, id = param.id, inverted = param.inverted, variantType = param.variant;
    var ref, ref1;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var variants = (0,redux/* useAppSelector */.CG)(function(state) {
        return state.productSlice.staticPageVariants;
    });
    (0,react.useEffect)(function() {
        fetchVariantsWithFilter(0, 6);
    }, []);
    var fetchVariantsWithFilter = function(offset, pageSize) {
        var filter = [
            {
                value: pageSize.toString(),
                param: "size",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: offset.toString(),
                param: "offset",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            }
        ];
        if (variantType === ArticlePageProductTeaserVariant.UNIQUE_INSTANCES) {
            filter = _toConsumableArray(filter).concat([
                {
                    value: "1",
                    param: "mintingCount",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                },
                {
                    value: "OPEN",
                    param: "status",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                }
            ]);
        } else {
            filter = _toConsumableArray(filter).concat([
                {
                    value: encodeURIComponent((0,time_helper/* dateToISOString */.CI)(new Date())),
                    param: "saleFrom",
                    comparisonType: filter_expression_enum/* FilterExpression.greaterThan */.p.greaterThan
                },
                {
                    param: "sort",
                    comparisonType: filter_expression_enum/* FilterExpression.none */.p.none,
                    value: "salesAttribute.saleFrom,asc"
                }
            ]);
        }
        dispatch((0,redux/* fetchStaticPageVariants */.ou)(filter));
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
        id: id,
        headline: headline,
        maxCards: variants === null || variants === void 0 ? void 0 : variants.maxNumber,
        headlineElement: "h2",
        inverted: inverted,
        pending: variants.pending,
        cards: (ref2 = variants === null || variants === void 0 ? void 0 : (ref = variants.data) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(variant) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                variant: variant,
                inverted: inverted
            }, "article-page-variant-teaser-".concat(variant.id));
        })) !== null && ref2 !== void 0 ? ref2 : [],
        onLoadNewItems: function(data) {
            fetchVariantsWithFilter(data.pageOrOffset, data.size);
        },
        type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
    });
};
ArticlePageProductTeaser.defaultProps = {
    variant: ArticlePageProductTeaserVariant.FUTURE_RELEASE
};

// EXTERNAL MODULE: ./src/components/article-page/article-page-temp-header/article-page-temp-header.tsx + 4 modules
var article_page_temp_header = __webpack_require__(392);
// EXTERNAL MODULE: ./src/utils/_enums/strapi-teaser-element-types.enum.tsx
var strapi_teaser_element_types_enum = __webpack_require__(58289);
;// CONCATENATED MODULE: ./src/components/article-page/article-page-variants-instances-teaser/article-page-variants-instances-teaser.tsx
function article_page_variants_instances_teaser_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function article_page_variants_instances_teaser_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return article_page_variants_instances_teaser_arrayLikeToArray(arr);
}
function article_page_variants_instances_teaser_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function article_page_variants_instances_teaser_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function article_page_variants_instances_teaser_toConsumableArray(arr) {
    return article_page_variants_instances_teaser_arrayWithoutHoles(arr) || article_page_variants_instances_teaser_iterableToArray(arr) || article_page_variants_instances_teaser_unsupportedIterableToArray(arr) || article_page_variants_instances_teaser_nonIterableSpread();
}
function article_page_variants_instances_teaser_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return article_page_variants_instances_teaser_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return article_page_variants_instances_teaser_arrayLikeToArray(o, minLen);
}










var ArticlePageVariantsInstancesTeaser = function(param) {
    var headline = param.headline, variantType = param.variant, elementType = param.elementType, elementIds = param.elementIds, inverted = param.inverted, teaserIdentifier = param.teaserIdentifier;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var ref2 = (0,redux/* useAppSelector */.CG)(function(state) {
        return {
            elements: state.productSlice.variantInstancesElements.find(function(item) {
                return item.teaserIdentifier === teaserIdentifier;
            }),
            user: state.userSlice.user,
            walletId: state.blockchainSlice.walletId,
            addToBasketModelPending: state.checkoutSlice.pending,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus
        };
    }), elements = ref2.elements, user = ref2.user, walletId = ref2.walletId, addToBasketModelPending = ref2.addToBasketModelPending, addToBasketStatus = ref2.addToBasketStatus;
    (0,react.useEffect)(function() {
        fetchElementsByIds(0, 6);
    }, []);
    var fetchElementsByIds = function(offset, pageSize) {
        var filter = [
            {
                value: pageSize.toString(),
                param: "size",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            },
            {
                value: offset.toString(),
                param: "offset",
                comparisonType: filter_expression_enum/* FilterExpression.none */.p.none
            }
        ];
        elementIds.forEach(function(element) {
            var ref;
            var ref1;
            filter = article_page_variants_instances_teaser_toConsumableArray(filter).concat([
                {
                    value: (ref1 = element === null || element === void 0 ? void 0 : (ref = element.elementId) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref1 !== void 0 ? ref1 : "",
                    param: "id",
                    comparisonType: filter_expression_enum/* FilterExpression.equals */.p.equals
                }
            ]);
        });
        dispatch((0,redux/* fetchElements */.XM)({
            filter: filter,
            elementType: elementType,
            identifier: teaserIdentifier
        }));
    };
    if (elements && elements.data.length > 0) {
        if (elementType === strapi_teaser_element_types_enum/* StrapiTeaserElementTypes.VARIANTS */.I.VARIANTS) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                    headline: headline.headlineContent,
                    headlineStyle: headline.textAlign,
                    inverted: inverted,
                    maxCards: elements.maxNumber,
                    headlineElement: headline.element,
                    headlineVariant: (0,strapi_mapper/* mapStrapiHeadline */.z)(headline.style),
                    withNumbers: true,
                    hideTeaserButtons: false,
                    pending: elements.pending,
                    pagination: undefined,
                    cards: elements.data.map(function(variant) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                            variant: variant,
                            inverted: inverted
                        }, "article-page-variant-".concat(variant.id));
                    }),
                    onLoadNewItems: function(data) {
                        fetchElementsByIds(data.pageOrOffset, data.size);
                    },
                    type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                    headline: headline.headlineContent,
                    hideTeaserButtons: false,
                    inverted: inverted,
                    maxCards: elements.maxNumber,
                    headlineElement: headline.element,
                    headlineVariant: (0,strapi_mapper/* mapStrapiHeadline */.z)(headline.style),
                    withNumbers: true,
                    pending: elements.pending,
                    pagination: undefined,
                    cards: elements.data.map(function(instance) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                            instance: instance,
                            inverted: inverted
                        }, "article-page-variant-".concat(instance.id));
                    }),
                    onLoadNewItems: function(data) {
                        fetchElementsByIds(data.pageOrOffset, data.size);
                    },
                    type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
                })
            });
        }
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};

// EXTERNAL MODULE: ./src/components/register/register-form/register-form-light.tsx + 1 modules
var register_form_light = __webpack_require__(17750);
// EXTERNAL MODULE: ./src/pages/_app.tsx + 13 modules
var _app = __webpack_require__(86815);
// EXTERNAL MODULE: ./src/utils/_enums/article-page-types.tsx
var article_page_types = __webpack_require__(88092);
// EXTERNAL MODULE: ./src/utils/_enums/image-content-type.enum.tsx
var image_content_type_enum = __webpack_require__(26884);
// EXTERNAL MODULE: ./src/utils/_helper/enum-to-language-mapper.tsx
var enum_to_language_mapper = __webpack_require__(15487);
// EXTERNAL MODULE: ./src/views/article-page/article-page.module.scss
var article_page_module = __webpack_require__(64826);
var article_page_module_default = /*#__PURE__*/__webpack_require__.n(article_page_module);
;// CONCATENATED MODULE: ./src/views/article-page/article-page.tsx
function article_page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function article_page_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return article_page_arrayLikeToArray(arr);
}
function article_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_page_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function article_page_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function article_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function article_page_toConsumableArray(arr) {
    return article_page_arrayWithoutHoles(arr) || article_page_iterableToArray(arr) || article_page_unsupportedIterableToArray(arr) || article_page_nonIterableSpread();
}
function article_page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return article_page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return article_page_arrayLikeToArray(o, minLen);
}










































var resolveElementForData = function(_param, elements, index1, inverted) {
    var __component = _param.__component, props = _objectWithoutProperties(_param, [
        "__component"
    ]);
    switch(__component){
        case "atoms.headline":
            {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                var ref7, ref8;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (ref7 = (ref = props) === null || ref === void 0 ? void 0 : ref.cssClass) !== null && ref7 !== void 0 ? ref7 : "",
                    element: (ref1 = props) === null || ref1 === void 0 ? void 0 : ref1.element,
                    inverted: inverted,
                    variant: (0,strapi_mapper/* mapStrapiHeadline */.z)((ref2 = props) === null || ref2 === void 0 ? void 0 : ref2.style),
                    style: {
                        textAlign: (ref8 = (ref3 = props) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.textAlign) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.toLowerCase) === null || ref5 === void 0 ? void 0 : ref5.call(ref4)) !== null && ref8 !== void 0 ? ref8 : "left"
                    },
                    children: (ref6 = props) === null || ref6 === void 0 ? void 0 : ref6.headlineContent
                });
            }
        case "atoms.paragraph":
            {
                var ref9, ref10;
                var ref11;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (ref9 = props) === null || ref9 === void 0 ? void 0 : ref9.cssClass,
                    inverted: inverted,
                    variant: typeography_variants_enum/* TypographyVariantsEnum.PARAGRAPH */.H.PARAGRAPH,
                    children: (0,html_react_parser/* default */.ZP)((ref11 = (ref10 = props) === null || ref10 === void 0 ? void 0 : ref10.content) !== null && ref11 !== void 0 ? ref11 : "")
                });
            }
        case "atoms.topline":
            {
                var ref12, ref13;
                var ref14;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (ref12 = props) === null || ref12 === void 0 ? void 0 : ref12.cssClass,
                    inverted: inverted,
                    variant: typeography_variants_enum/* TypographyVariantsEnum.TOPLINE_OR_LABEL */.H.TOPLINE_OR_LABEL,
                    children: (0,html_react_parser/* default */.ZP)((ref14 = (ref13 = props) === null || ref13 === void 0 ? void 0 : ref13.toplineContent) !== null && ref14 !== void 0 ? ref14 : "")
                });
            }
        case "atoms.image":
            {
                var ref15, ref16, ref17, ref18;
                var ref19, ref20;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                    src: (ref15 = props) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.imageUpload) === null || ref16 === void 0 ? void 0 : ref16.url,
                    alt: (ref19 = (ref17 = props) === null || ref17 === void 0 ? void 0 : ref17.altText) !== null && ref19 !== void 0 ? ref19 : "",
                    className: (ref20 = (ref18 = props) === null || ref18 === void 0 ? void 0 : ref18.cssClass) !== null && ref20 !== void 0 ? ref20 : ""
                });
            }
        case "atoms.bookmark":
            {
                var ref21;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageBookmark, {
                    id: (ref21 = props) === null || ref21 === void 0 ? void 0 : ref21.identifier
                });
            }
        case "atoms.primary-button":
            {
                var ref22, ref23, ref24, ref25;
                var ref26, ref27;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: (ref26 = (ref22 = props) === null || ref22 === void 0 ? void 0 : ref22.buttonUrl) !== null && ref26 !== void 0 ? ref26 : "",
                    target: ((ref23 = props) === null || ref23 === void 0 ? void 0 : ref23.external) ? "_blank" : undefined,
                    rel: ((ref24 = props) === null || ref24 === void 0 ? void 0 : ref24.external) ? "noreferrer" : undefined,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        variant: button_variants_enum/* ButtonVariantsEnum.PRIMARY */.l.PRIMARY,
                        inverted: inverted,
                        children: (ref27 = (ref25 = props) === null || ref25 === void 0 ? void 0 : ref25.buttonText) !== null && ref27 !== void 0 ? ref27 : ""
                    })
                });
            }
        case "teaser.podcast-teaser":
            {
                var ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45;
                var ref46, ref47, ref48, ref49, ref50;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(basic_card/* default */.Z, {
                    media: {
                        mediaUrl: (ref46 = (ref28 = props) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.podcastImage) === null || ref29 === void 0 ? void 0 : ref29.url) !== null && ref46 !== void 0 ? ref46 : "",
                        contentType: image_content_type_enum/* MediaContentType.PNG */.L.PNG
                    },
                    category: enum_to_language_mapper/* EnumToLanguageMapper.categoryIdToCategoryEnum */.H.categoryIdToCategoryEnum(1),
                    type: basic_card_variants_enum/* BasicCardVariants.PODCAST_TEASER */.I.PODCAST_TEASER,
                    duration: (ref47 = (ref30 = props) === null || ref30 === void 0 ? void 0 : ref30.duration) !== null && ref47 !== void 0 ? ref47 : "",
                    redirectUrl: (ref48 = (ref31 = props) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.readMoreLink) === null || ref32 === void 0 ? void 0 : ref32.url) !== null && ref48 !== void 0 ? ref48 : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(podcast_teaser_card, {
                        text: {
                            headline: (ref33 = props) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.headline) === null || ref34 === void 0 ? void 0 : ref34.headlineContent,
                            topline: (ref35 = props) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.topline) === null || ref36 === void 0 ? void 0 : ref36.toplineContent,
                            description: (ref37 = props) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.description) === null || ref38 === void 0 ? void 0 : ref38.content
                        },
                        footer: {
                            onPrimaryAction: function() {
                                return;
                            },
                            date: (ref39 = props) === null || ref39 === void 0 ? void 0 : ref39.date
                        },
                        type: basic_card_variants_enum/* BasicCardVariants.PODCAST_TEASER */.I.PODCAST_TEASER,
                        isURLExternal: (ref40 = props) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.readMoreLink) === null || ref41 === void 0 ? void 0 : ref41.external,
                        moreInfoLinkText: (ref49 = (ref42 = props) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.readMoreLink) === null || ref43 === void 0 ? void 0 : ref43.linkText) !== null && ref49 !== void 0 ? ref49 : "",
                        redirectUrl: (ref50 = (ref44 = props) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.readMoreLink) === null || ref45 === void 0 ? void 0 : ref45.url) !== null && ref50 !== void 0 ? ref50 : ""
                    })
                });
            }
        case "teaser.content-teaser-small":
            {
                var ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_only_teaser, {
                    footer: {
                        onMoreInfo: function() {
                            return;
                        },
                        onAction: function() {
                            return;
                        }
                    },
                    imageUrl: (ref51 = props) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.contentTeaserSmallImage) === null || ref52 === void 0 ? void 0 : ref52.url,
                    inverted: inverted,
                    size: TextOnlyTeaserSizes.SMALL,
                    text: {
                        description: (ref53 = props) === null || ref53 === void 0 ? void 0 : ref53.paragraph.content,
                        headline: (ref54 = props) === null || ref54 === void 0 ? void 0 : ref54.headline,
                        subHeadline: (ref55 = props) === null || ref55 === void 0 ? void 0 : ref55.subtitle,
                        buttonText: (ref56 = props) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.link) === null || ref57 === void 0 ? void 0 : ref57.linkText
                    },
                    buttonUrl: (ref58 = props) === null || ref58 === void 0 ? void 0 : ref58.link,
                    ghostButton: (ref59 = props) === null || ref59 === void 0 ? void 0 : ref59.ghostButton,
                    video: props.video
                });
            }
        case "atoms.spacer":
            {
                var ref60;
                var ref61;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                    width: "100%",
                    height: "".concat((ref61 = (ref60 = props) === null || ref60 === void 0 ? void 0 : ref60.margin) !== null && ref61 !== void 0 ? ref61 : 0, "px")
                });
            }
        case "atoms.video":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                    platform: props.platform,
                    videoId: props.videoId,
                    controls: props.controls,
                    autoplay: props.autoplay
                });
            }
        case "organisms.content-teaser":
            {
                var ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70;
                var buttons = [];
                (ref62 = props) === null || ref62 === void 0 ? void 0 : ref62.CTA.forEach(function(item, index) {
                    var ref, ref114, ref115, ref116, ref117, ref118, ref119, ref120;
                    var buttonStyle;
                    switch((ref114 = (ref = props) === null || ref === void 0 ? void 0 : ref.CTA[index]) === null || ref114 === void 0 ? void 0 : ref114.buttonStyle){
                        case "secondary":
                            buttonStyle = button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED;
                            break;
                        case "inline":
                            buttonStyle = button_variants_enum/* ButtonVariantsEnum.SECONDARY_FILLED */.l.SECONDARY_FILLED;
                            break;
                        case "outline":
                            buttonStyle = button_variants_enum/* ButtonVariantsEnum.SECONDARY_OUTLINED */.l.SECONDARY_OUTLINED;
                            break;
                        case "text":
                            buttonStyle = button_variants_enum/* ButtonVariantsEnum.SELECTED */.l.SELECTED;
                            break;
                        default:
                            buttonStyle = button_variants_enum/* ButtonVariantsEnum.PRIMARY */.l.PRIMARY;
                    }
                    var ref121;
                    buttons.push({
                        variant: buttonStyle,
                        children: (ref116 = (ref115 = props) === null || ref115 === void 0 ? void 0 : ref115.CTA[index]) === null || ref116 === void 0 ? void 0 : ref116.buttonText,
                        buttonUrl: (ref121 = (ref118 = (ref117 = props) === null || ref117 === void 0 ? void 0 : ref117.CTA[index]) === null || ref118 === void 0 ? void 0 : ref118.buttonUrl) !== null && ref121 !== void 0 ? ref121 : "",
                        external: (ref120 = (ref119 = props) === null || ref119 === void 0 ? void 0 : ref119.CTA[index]) === null || ref120 === void 0 ? void 0 : ref120.external
                    });
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_image_teaser/* default */.Z, {
                    callToAction: buttons,
                    image: (ref63 = props) === null || ref63 === void 0 ? void 0 : ref63.Content_image,
                    video: props.video,
                    headline: (ref64 = props) === null || ref64 === void 0 ? void 0 : ref64.Headline,
                    topline: {
                        toplineContent: (ref65 = props) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.topline) === null || ref66 === void 0 ? void 0 : ref66.toplineContent,
                        cssClass: ""
                    },
                    inverted: inverted,
                    description: {
                        content: (ref67 = props) === null || ref67 === void 0 ? void 0 : ref67.text_content,
                        cssClass: ""
                    },
                    imagePosition: ((ref68 = props) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.componentStyles) === null || ref69 === void 0 ? void 0 : ref69.isLeft) ? horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT : horizontal_position_enum/* HorizontalPosition.RIGHT */.D.RIGHT,
                    imgEdgePosition: (ref70 = props) === null || ref70 === void 0 ? void 0 : ref70.imgEdgePosition
                });
            }
        case "teaser.variants-instances-teaser":
            {
                var ref71, ref72, ref73, ref74;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageVariantsInstancesTeaser, {
                    inverted: inverted,
                    headline: (ref71 = props) === null || ref71 === void 0 ? void 0 : ref71.headline,
                    elementType: (ref72 = props) === null || ref72 === void 0 ? void 0 : ref72.elementType,
                    elementIds: (ref73 = props) === null || ref73 === void 0 ? void 0 : ref73.elementIds,
                    teaserIdentifier: (ref74 = props) === null || ref74 === void 0 ? void 0 : ref74.id
                });
            }
        case "molecules.produkt-teaser":
            {
                var ref75, ref76, ref77;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageProductTeaser, {
                    variant: (ref75 = props) === null || ref75 === void 0 ? void 0 : ref75.variant,
                    headline: (ref76 = props) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.headline) === null || ref77 === void 0 ? void 0 : ref77.headlineContent,
                    inverted: inverted
                });
            }
        case "molecules.number-text-teaser":
            {
                var ref78, ref79;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(number_text_teaser, {
                    largeText: (ref78 = props) === null || ref78 === void 0 ? void 0 : ref78.largeText,
                    subText: (ref79 = props) === null || ref79 === void 0 ? void 0 : ref79.subText
                });
            }
        case "organisms.newsletter":
            {
                var ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_page_newsletter, {
                    headline: (ref80 = props) === null || ref80 === void 0 ? void 0 : ref80.headline,
                    description: (ref81 = props) === null || ref81 === void 0 ? void 0 : ref81.description,
                    errorSnackbar: (ref82 = props) === null || ref82 === void 0 ? void 0 : ref82.errorSnackbar,
                    successSnackbar: (ref83 = props) === null || ref83 === void 0 ? void 0 : ref83.successSnackbar,
                    backgroundImage: (ref84 = props) === null || ref84 === void 0 ? void 0 : ref84.backgroundImage,
                    inverted: (ref85 = props) === null || ref85 === void 0 ? void 0 : ref85.inverted,
                    newsletterInput: {
                        id: 0,
                        fieldType: "text",
                        fieldName: "newsletter",
                        fieldLabel: (ref86 = props) === null || ref86 === void 0 ? void 0 : ref86.newsletterPlaceholder,
                        fieldHint: (ref87 = props) === null || ref87 === void 0 ? void 0 : ref87.newsletterPlaceholder,
                        fieldErrorMessages: {
                            id: 0,
                            required: (ref88 = props) === null || ref88 === void 0 ? void 0 : ref88.inputRequiredError,
                            valid: (ref89 = props) === null || ref89 === void 0 ? void 0 : ref89.validEmailError
                        }
                    }
                });
            }
        case "molecules.faq-section":
            {
                var ref90, ref91, ref92, ref93;
                var ref94, ref95, ref96;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePageFaqBox, {
                    Headline: (ref94 = (ref90 = props) === null || ref90 === void 0 ? void 0 : ref90.Headline) !== null && ref94 !== void 0 ? ref94 : "",
                    fa_qs: (ref95 = (ref91 = props) === null || ref91 === void 0 ? void 0 : ref91.fa_qs) !== null && ref95 !== void 0 ? ref95 : []
                }, (ref96 = (ref92 = props) === null || ref92 === void 0 ? void 0 : (ref93 = ref92.Headline) === null || ref93 === void 0 ? void 0 : ref93.headlineContent) !== null && ref96 !== void 0 ? ref96 : "");
            }
        case "molecules.quote-section":
            {
                var ref97, ref98, ref99, ref100, ref101, ref102;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(quote_section, {
                    inverted: inverted,
                    text: (ref97 = props) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.text) === null || ref98 === void 0 ? void 0 : ref98.content,
                    authorName: (ref99 = props) === null || ref99 === void 0 ? void 0 : ref99.authorName,
                    authorTitle: (ref100 = props) === null || ref100 === void 0 ? void 0 : ref100.authorTitle,
                    authorImage: (ref101 = props) === null || ref101 === void 0 ? void 0 : ref101.authorImage,
                    alignment: (ref102 = props) === null || ref102 === void 0 ? void 0 : ref102.alignment
                });
            }
        case "organisms.head-image-section":
            {
                var ref103, ref104, ref105, ref106;
                var ref107;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(head_image_section, {
                    imageUrl: (ref103 = props) === null || ref103 === void 0 ? void 0 : (ref104 = ref103.headImageMain) === null || ref104 === void 0 ? void 0 : ref104.url,
                    inverted: inverted,
                    alt: (ref107 = (ref105 = props) === null || ref105 === void 0 ? void 0 : (ref106 = ref105.headImageMain) === null || ref106 === void 0 ? void 0 : ref106.alternativeText) !== null && ref107 !== void 0 ? ref107 : "",
                    caption: props.caption
                });
            }
        case "organisms.head-image-with-text-section":
            {
                var ref108, ref109, ref110, ref111, ref112;
                var ref113;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(head_image_with_text_section, {
                    imageUrl: (ref108 = props) === null || ref108 === void 0 ? void 0 : (ref109 = ref108.headImage) === null || ref109 === void 0 ? void 0 : ref109.url,
                    alt: (ref113 = (ref110 = props) === null || ref110 === void 0 ? void 0 : (ref111 = ref110.headImage) === null || ref111 === void 0 ? void 0 : ref111.alternativeText) !== null && ref113 !== void 0 ? ref113 : "",
                    caption: props.caption,
                    inverted: inverted,
                    text: props.text,
                    imagePosition: ((ref112 = props) === null || ref112 === void 0 ? void 0 : ref112.imagePosition) === horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT ? horizontal_position_enum/* HorizontalPosition.LEFT */.D.LEFT : horizontal_position_enum/* HorizontalPosition.RIGHT */.D.RIGHT
                });
            }
        case "organisms.flexcontainer":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: function() {
                            var ref;
                            switch((ref = props) === null || ref === void 0 ? void 0 : ref.horizontalAlignment){
                                case HorizontalAlignment.RIGHT:
                                    return "flex-end";
                                case HorizontalAlignment.CENTER:
                                    return "center";
                                case HorizontalAlignment.SPACE_AROUND:
                                    return "space-around";
                                case HorizontalAlignment.SPACE_BETWEEN:
                                    return "space-between";
                                case HorizontalAlignment.SPACE_EVENLY:
                                    return "space-evenly";
                                default:
                                    return "flex-start";
                            }
                        }(),
                        alignItems: function() {
                            var ref;
                            switch((ref = props) === null || ref === void 0 ? void 0 : ref.verticalAlignment){
                                case VerticalAlignment.BOTTOM:
                                    return "flex-end";
                                case VerticalAlignment.CENTER:
                                    return "center";
                                case VerticalAlignment.BASELINE:
                                    return "baseline";
                                case VerticalAlignment.STRETCH:
                                    return "stretch";
                                default:
                                    return "flex-start";
                            }
                        }(),
                        flexWrap: "wrap"
                    },
                    children: function() {
                        var ref125;
                        var selectedArray = article_page_toConsumableArray(elements.slice(index1 + 1, index1 + ((ref125 = props) === null || ref125 === void 0 ? void 0 : ref125.numberOfChildren) + 1));
                        var preArray = elements === null || elements === void 0 ? void 0 : elements.slice(0, index1 + 1);
                        var postArray = elements === null || elements === void 0 ? void 0 : elements.slice(index1 + props.numberOfChildren + 1, elements.length - 1);
                        elements = article_page_toConsumableArray(preArray).concat(article_page_toConsumableArray(postArray));
                        var ref122, ref123;
                        return selectedArray.map(function(element, newIndex, array) {
                            var ref, ref124;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                style: {
                                    maxWidth: "312px",
                                    margin: "".concat((ref122 = (ref = props) === null || ref === void 0 ? void 0 : ref.columnGap) !== null && ref122 !== void 0 ? ref122 : 0, "px ").concat((ref123 = (ref124 = props) === null || ref124 === void 0 ? void 0 : ref124.rowGap) !== null && ref123 !== void 0 ? ref123 : 0, "px")
                                },
                                children: resolveElementForData(element, array, newIndex, inverted)
                            }, newIndex);
                        });
                    }()
                });
            }
        case "molecules.contact-form":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form/* default */.Z, {
                    inverted: inverted
                });
            }
        case "organisms.register-form-light":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(register_form_light/* RegisterFormLight */.c, article_page_objectSpread({}, props));
            }
    }
};
var ArticlePage = function(param) {
    var pageData = param.pageData, type = param.type;
    var data;
    if (pageData) {
        data = pageData;
    } else {
        data = useArticlePage();
    }
    var router = (0,client_router.useRouter)();
    (0,react.useEffect)(function() {
        var ref;
        var ref153;
        var url = (ref153 = location === null || location === void 0 ? void 0 : location.href) !== null && ref153 !== void 0 ? ref153 : "";
        var idInUrl = (ref = url.match(/#[A-Za-zäöüÄÖÜ]+/)) === null || ref === void 0 ? void 0 : ref[0];
        if (!idInUrl && (type === article_page_types/* ArticlePageTypes.ARTICLE_PAGE_STRAPIID */.W.ARTICLE_PAGE_STRAPIID || type === article_page_types/* ArticlePageTypes.CONFIRMATION_PAGE_STRAPIID */.W.CONFIRMATION_PAGE_STRAPIID) && data && (data === null || data === void 0 ? void 0 : data.urlReadablePageTitle)) {
            var prefix = type === article_page_types/* ArticlePageTypes.ARTICLE_PAGE_STRAPIID */.W.ARTICLE_PAGE_STRAPIID ? "/s/" : "/c/";
            router.push(prefix + (data === null || data === void 0 ? void 0 : data.urlReadablePageTitle));
        }
    }, [
        data
    ]);
    if (data) {
        var ref154, ref126, ref127, ref128, ref129, ref130, ref131, ref132, ref133, ref134, ref135, ref136, ref137, ref138, ref139, ref140, ref141, ref142, ref143, ref144, ref145, ref146, ref147;
        var ref148, ref149, ref150, ref151, ref152;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: data.inverted ? (article_page_module_default()).inverted : "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
                header: (data === null || data === void 0 ? void 0 : data.headerType) === "TEMP" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(article_page_temp_header/* ArticlePageTempHeader */.H, {
                    forStaticPage: true,
                    pageType: type,
                    availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
                    forStaticPage: true,
                    pageType: type,
                    availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
                }),
                stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(stage/* Stage */.H, {
                    inverted: (ref148 = data === null || data === void 0 ? void 0 : (ref154 = data.stage) === null || ref154 === void 0 ? void 0 : (ref126 = ref154.componentStyles) === null || ref126 === void 0 ? void 0 : ref126.inverted) !== null && ref148 !== void 0 ? ref148 : true,
                    logo: (data === null || data === void 0 ? void 0 : (ref127 = data.stage) === null || ref127 === void 0 ? void 0 : ref127.showLogo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_text_svg/* LogoText */.Y, {
                        width: "400px",
                        fill: "white"
                    }) : null,
                    description: (ref149 = data === null || data === void 0 ? void 0 : (ref128 = data.stage) === null || ref128 === void 0 ? void 0 : (ref129 = ref128.paragraph) === null || ref129 === void 0 ? void 0 : ref129.content) !== null && ref149 !== void 0 ? ref149 : "",
                    background: data === null || data === void 0 ? void 0 : (ref130 = data.stage) === null || ref130 === void 0 ? void 0 : (ref131 = ref130.background) === null || ref131 === void 0 ? void 0 : ref131.url,
                    verticalOrientation: (ref150 = data === null || data === void 0 ? void 0 : (ref132 = data.stage) === null || ref132 === void 0 ? void 0 : (ref133 = ref132.componentStyles) === null || ref133 === void 0 ? void 0 : ref133.verticaltextOrientation) !== null && ref150 !== void 0 ? ref150 : "CENTER",
                    title: data === null || data === void 0 ? void 0 : (ref134 = data.stage) === null || ref134 === void 0 ? void 0 : ref134.headline.headlineContent,
                    titleVariant: data === null || data === void 0 ? void 0 : (ref135 = data.stage) === null || ref135 === void 0 ? void 0 : (ref136 = ref135.headline) === null || ref136 === void 0 ? void 0 : ref136.style,
                    size: (ref151 = data === null || data === void 0 ? void 0 : (ref137 = data.stage) === null || ref137 === void 0 ? void 0 : (ref138 = ref137.componentStyles) === null || ref138 === void 0 ? void 0 : ref138.size) !== null && ref151 !== void 0 ? ref151 : "Large",
                    orientation: (ref152 = data === null || data === void 0 ? void 0 : (ref139 = data.stage) === null || ref139 === void 0 ? void 0 : (ref140 = ref139.componentStyles) === null || ref140 === void 0 ? void 0 : ref140.textAlign) !== null && ref152 !== void 0 ? ref152 : "CENTER",
                    buttons: (data === null || data === void 0 ? void 0 : (ref141 = data.stage) === null || ref141 === void 0 ? void 0 : ref141.cta) ? [
                        {
                            buttonUrl: data === null || data === void 0 ? void 0 : (ref142 = data.stage) === null || ref142 === void 0 ? void 0 : (ref143 = ref142.cta) === null || ref143 === void 0 ? void 0 : ref143.buttonUrl,
                            children: data === null || data === void 0 ? void 0 : (ref144 = data.stage) === null || ref144 === void 0 ? void 0 : (ref145 = ref144.cta) === null || ref145 === void 0 ? void 0 : ref145.buttonText,
                            external: data === null || data === void 0 ? void 0 : (ref146 = data.stage) === null || ref146 === void 0 ? void 0 : (ref147 = ref146.cta) === null || ref147 === void 0 ? void 0 : ref147.external
                        }
                    ] : undefined
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((article_page_module_default())["article-page"], "\n                    ").concat((article_page_module_default())["".concat(data.bodyVariant)]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                            tags: data.meta,
                            articlePageType: type
                        }),
                        function() {
                            var elements = data === null || data === void 0 ? void 0 : data.body;
                            var flexEndPos = null;
                            var isFlexRoot = false;
                            return elements.map(function(element, index) {
                                if (element.__component === "organisms.flexcontainer") {
                                    isFlexRoot = true;
                                    flexEndPos = index + element.numberOfChildren;
                                } else {
                                    isFlexRoot = false;
                                }
                                if (flexEndPos && index > flexEndPos) {
                                    flexEndPos = null;
                                }
                                var ref;
                                if (flexEndPos === null || isFlexRoot) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: element.__component,
                                    style: (element === null || element === void 0 ? void 0 : element.__component) === "atoms.bookmark" ? {
                                        margin: "unset",
                                        width: 0
                                    } : undefined,
                                    children: resolveElementForData(element, elements, index, (ref = data === null || data === void 0 ? void 0 : data.inverted) !== null && ref !== void 0 ? ref : false)
                                }, index);
                            });
                        }()
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
ArticlePage.dataHooks = [
    useArticlePage
].concat(article_page_toConsumableArray(_app["default"].dataHooks), article_page_toConsumableArray(contact_form/* default.dataHooks */.Z.dataHooks), article_page_toConsumableArray(header_footer_wrapper/* HeaderFooterWrapper.dataHooks */.u.dataHooks), article_page_toConsumableArray(article_page_temp_header/* ArticlePageTempHeader.dataHooks */.H.dataHooks), article_page_toConsumableArray(register_form_light/* RegisterFormLight.dataHooks */.c.dataHooks), article_page_toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));


/***/ }),

/***/ 43995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","faq-box":"faq-box_faq-box__MqXG2","faq-item-content":"faq-box_faq-item-content__KCuEB","faq-item-description-wrapper":"faq-box_faq-item-description-wrapper__rsxgn","faq-item-description":"faq-box_faq-item-description__phFP_","faq-item-image":"faq-box_faq-item-image__OJ_O_","faq-description":"faq-box_faq-description__29fa_"};

/***/ }),

/***/ 84059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"head-image-wrapper":"head-image-section_head-image-wrapper__922lh"};

/***/ }),

/***/ 9183:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","head-image-with-text-wrapper":"head-image-with-text-section_head-image-with-text-wrapper__0NwkL","image-wrapper":"head-image-with-text-section_image-wrapper__Yw_Dr","text-container":"head-image-with-text-section_text-container__6qyfo","left":"head-image-with-text-section_left__lUHes","right":"head-image-with-text-section_right__Sp_gw"};

/***/ }),

/***/ 59242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","number-text-teaser":"number-text-teaser_number-text-teaser__F2gAY"};

/***/ }),

/***/ 70482:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","podcast-teaser-card-wrapper":"podcast-teaser-card_podcast-teaser-card-wrapper__nfUO7","teaser-card-text":"podcast-teaser-card_teaser-card-text__JIGXB","optional-info":"podcast-teaser-card_optional-info__uDaZy","label-wrapper":"podcast-teaser-card_label-wrapper__V68JW","label-container":"podcast-teaser-card_label-container__D_DpT","label":"podcast-teaser-card_label__p7OOm","podcast-teaser":"podcast-teaser-card_podcast-teaser__0ba3M"};

/***/ }),

/***/ 46907:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","quote-section":"quote-section_quote-section__eIyal","author-image":"quote-section_author-image__yuyQs","quote-wrapper":"quote-section_quote-wrapper__yfFsb","quote":"quote-section_quote__xx_3G","inverted":"quote-section_inverted__pzACN","author-name":"quote-section_author-name__X0AuT","author-title":"quote-section_author-title__cWLWb","left":"quote-section_left__p32cV","center":"quote-section_center__Az1_N","right":"quote-section_right__7ve53"};

/***/ }),

/***/ 34402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-image-teaser":"text-image-teaser_text-image-teaser__c2PVh","right-wrapper":"text-image-teaser_right-wrapper__neasV","left-wrapper":"text-image-teaser_left-wrapper__arlxV","right-wrapper-img":"text-image-teaser_right-wrapper-img__NE9tT","left-wrapper-img":"text-image-teaser_left-wrapper-img__pqjW6","buttons":"text-image-teaser_buttons__iNgQg","button-1":"text-image-teaser_button-1__0qLfp","button-2":"text-image-teaser_button-2__5iNSC","overTheEdge":"text-image-teaser_overTheEdge__GCO1C"};

/***/ }),

/***/ 84298:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","text-only-teaser-wrapper":"text-only-teaser_text-only-teaser-wrapper__jua4H","text":"text-only-teaser_text__70yy1","footer":"text-only-teaser_footer__VMpdS","text-only-teaser-wrapper-small":"text-only-teaser_text-only-teaser-wrapper-small__sdg0n","text-only-teaser-wrapper-medium":"text-only-teaser_text-only-teaser-wrapper-medium__GmF8q","text-only-teaser-wrapper-large":"text-only-teaser_text-only-teaser-wrapper-large__o5KWZ","link":"text-only-teaser_link__kSFTY"};

/***/ }),

/***/ 23553:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"video-component-wrapper":"video-component_video-component-wrapper__oQYhW"};

/***/ }),

/***/ 2815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-page-faq-box":"article-page-faq-box_article-page-faq-box__qc571"};

/***/ }),

/***/ 34775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","article-page-newsletter":"article-page-newsletter_article-page-newsletter__Px4WG","content":"article-page-newsletter_content__W4Y3o","newsletter-headline":"article-page-newsletter_newsletter-headline__2TObY","newsletter-input-wrapper":"article-page-newsletter_newsletter-input-wrapper__MWkEF","newsletter-input":"article-page-newsletter_newsletter-input__id8cZ"};

/***/ }),

/***/ 64826:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","article-page":"article-page_article-page__NWV4d","small":"article-page_small__uSjy4","large":"article-page_large__JWdm_","center":"article-page_center__FFZa6","left":"article-page_left__nmlqD","right":"article-page_right__a54BM","inverted":"article-page_inverted__IIVq0"};

/***/ })

}]);